import { firestore } from '../firebase'
import {
  ON_CLIENTS_CHANGE,
  REQUEST_CLIENTS
} from './types'

import {idNumber} from '../share/id_helper'
import {confirm} from '../components/dialogs'

const onClientsChange = (updates) => ({ type: ON_CLIENTS_CHANGE, updates })
const requestClients = () => ({type: REQUEST_CLIENTS})

export const listenForClientsChanges = () =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) throw new Error("Unknown Account")

    dispatch(requestClients())
    return firestore.collection('accounts').doc(account.currentAccountId)
      .collection('clients')
      .onSnapshot( snapshot => {
        const updates = { added: [], removed: [], modified: [] }

        snapshot.docChanges().forEach( change => {
          if(updates[change.type]) updates[change.type].push(
            {...change.doc.data(), id:change.doc.id}
          )
        })

        dispatch(onClientsChange(updates))
      }, error => console.log('ERROR:::::',error))
  }

export const createClient = (data) =>
  (dispatch, getState) => {
    const state = getState()
    if(!state.account || !state.account.currentAccountId) return Promise.resolve(null)
    // check redux if client already exists
    const index = state.clients.items.findIndex(c =>
      c.name === data.name && c.address === data.address
    )
    // return a promise with client if found
    if(index >= 0) return Promise.resolve(state.clients.items[index])

    // create new entry for client
    const newClientRef = firestore.collection('accounts')
                                .doc(state.account.currentAccountId)
                                .collection('clients')
                                .doc()
    // generate number and set createdAt
    const now = Date.now()
    const client = {...data,
      id: newClientRef.id,
      createdAt: now,
      number: idNumber(newClientRef.id,now)
    }

    // write to database and return promise with the new client
    return newClientRef.set(client).then(() => client)
  }


export const updateClient = (client) =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) return
    return firestore.collection('accounts')
                    .doc(account.currentAccountId)
                    .collection('clients')
                    .doc(client.id)
                    .set(client,{ merge: true })
  }

export const deleteClient = (clientId) =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) return
    return confirm('Damit wird diesen Kunden gelöscht!',{confirmLabel: 'Ok',abortLabel: 'Abbrechen'}).then(() =>
      firestore.collection('accounts')
                      .doc(account.currentAccountId)
                      .collection('clients')
                      .doc(clientId)
                      .delete()
    ).catch(error => console.log('ERROR::::',error))
  }



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/actions/clients.js